import { useTranslation } from 'react-i18next'
import { WaveProgress } from '@/src/renderer/components/ui/WaveProgress'
import { Button } from '@/src/renderer/components/ui/Button'
import './ClarifyHeader.scss'

export interface ClarifyHeaderProps {
  done: number
  total: number
  progress: number // 0..1
  onFinish: () => void
}

/**
 * Kopfzeile im Clarify-Mode:
 *   [Aufräumen]   [X von Y einsortiert]   [WaveProgress]   [Einsortieren K]
 */
export function ClarifyHeader({ done, total, progress, onFinish }: ClarifyHeaderProps) {
  const { t } = useTranslation()

  return (
    <div className="clarify-header">
      <span className="clarify-header__label">
        {t('quickNotes.clarify.subtitle')}
      </span>

      <span className="clarify-header__count">
        {t('quickNotes.clarify.progress', { done, total })}
      </span>

      <WaveProgress value={progress} />

      <Button
        variant="primary"
        shortcut={{ variant: 'character', text: 'K' }}
        onClick={onFinish}
        disabled={done === 0}
      >
        {done === 0
          ? t('quickNotes.clarify.done')
          : t('quickNotes.clarify.doneCount', { count: done })}
      </Button>
    </div>
  )
}
